/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParentWorkItemContext
 */
export interface ParentWorkItemContext {
    /**
     * 
     * @type {string}
     * @memberof ParentWorkItemContext
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ParentWorkItemContext
     */
    description?: string;
}

/**
 * Check if a given object implements the ParentWorkItemContext interface.
 */
export function instanceOfParentWorkItemContext(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ParentWorkItemContextFromJSON(json: any): ParentWorkItemContext {
    return ParentWorkItemContextFromJSONTyped(json, false);
}

export function ParentWorkItemContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentWorkItemContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function ParentWorkItemContextToJSON(value?: ParentWorkItemContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
    };
}

